import { fetchRestResponse } from '../../../common/fetch/fetch-rest-reponse';
import { getEnvironment } from '../../../common/utils/environment';
import { logger } from '../../../common/utils/logger';

import type { PinSearchTermOption } from './add-pin/add-pin-modal';
import type { ObjectResolverDataType, ObjectResolverParamType } from './types';

const OBJECT_RESOLVER_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';

export const getAdminhubLink = ({ orgId }: { orgId: string }): string => {
	const env = getEnvironment();
	const route = `o/${orgId}/rovo`;

	switch (env) {
		case 'development':
		case 'staging':
			return `https://admin.stg.atlassian.com/${route}`;
		default:
			return `https://admin.atlassian.com/${route}`;
	}
};

export const convertToKeyPhraseInputFormat = (keyPhraseValues: string[]): PinSearchTermOption[] =>
	keyPhraseValues.map((keyPhraseValue) => ({
		label: keyPhraseValue,
		value: keyPhraseValue,
	}));

export const fetchObjectResolver = async (url: string) => {
	try {
		const objectResolver = await fetchRestResponse<
			ObjectResolverParamType[],
			ObjectResolverDataType[]
		>({
			url: OBJECT_RESOLVER_ENDPOINT,
			body: [{ resourceUrl: url }],
		});

		if (!objectResolver || objectResolver[0].status !== 200) {
			logger.error({ error: 'REQUEST ERROR', functionName: 'convertToKeyPhraseInputFormat' });
			return null;
		}

		return objectResolver[0].body.data;
	} catch (error) {
		logger.error({ error, functionName: 'convertToKeyPhraseInputFormat' });
		return null;
	}
};
